import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ allowed, children }) {
  const role = localStorage.getItem("role"); // role from backend

  if (!role) return <Navigate to="/login" replace />; // not logged in
  if (!allowed.includes(role)) return <Navigate to="/unauthorized" replace />; // role not allowed

  return children; // allowed
}
